import React from 'react'
import { Cookies } from 'react-cookie'

const cookies = new Cookies();

const baseUrl = `custom/${cookies.get('customPath')}`
//const baseUrl = 'custom/generic'

const MainLogo = () => {
    let logoUrl = `${baseUrl}/mainlogo.svg`;
    return (
        <div className="divMainLogo">
            <img src={logoUrl} className="mainlogo" alt="logo" width="60%"></img>
        </div>
    );
};

const NavMenuLogo = () => {
    let logoUrl = `${baseUrl}/navmenulogo.svg`;
    return (
        <img className="nav-menu-logo-image" src={logoUrl} alt="logo" height="30"></img>
    );
};

const Style = () => {
    let styleUrl = `${baseUrl}/esigncustom.css`;
    return <link rel="stylesheet" type="text/css" href={styleUrl} />
}

const CustomTextsPath = () => (`${baseUrl}/esigncustom.json`);

// eslint-disable-next-line
export default { MainLogo, NavMenuLogo, Style, CustomTextsPath };